module.exports = __webpack_public_path__ + "assets/img/logo_bde.png?bf4abeaeb3437eb05d7a3baa062ebe6b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_bde.png
// module id = 1134
// module chunks = 0